import { Component, HostListener } from "@angular/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  menuOpen = false;
  mobileDropdownOpen = false;

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;

    if (!this.menuOpen) {
      this.mobileDropdownOpen = false;
    }
  }

  toggleMobileDropdown(): void {
    this.mobileDropdownOpen = !this.mobileDropdownOpen;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const clickedOutsideMenu =
      !target.closest("#mobile-menu") && !target.closest("#mobile-menu-button");

    if (clickedOutsideMenu && this.menuOpen) {
      this.menuOpen = false;
      this.mobileDropdownOpen = false;
    }
  }
}
